app.controller('RegisterCtrl', ['$scope', '$routeParams', '$http', '$window', '$q', 'appFactory',
function ($scope, $routeParams, $http, $window, $q, appFactory) {

    $scope.user = {};
    $scope.ListSales = [];

    $scope.user.PhoneCode = '+62';
    $scope.user.QuestionRDN = '1';

    $scope.disablesales = false;
    $scope.SalesSelected = '';
    $scope.ConfirmPassword = '';
    $scope.SalesSelected = '';

    $scope.disableBACA = false;
    $scope.disableBCA = false;

    $scope.page = 'step1';

    $scope.showPassword = false;
    $scope.inputType = 'password';
    $scope.toggleShowPassword = function () {
        $scope.showPassword = !$scope.showPassword;
        if ($scope.inputType == 'password')
            $scope.inputType = 'text';
        else
            $scope.inputType = 'password';
    }

    $scope.showPasswordConfirmation = false;
    $scope.inputTypeConfirmation = 'password';
    $scope.toggleShowPasswordConfirmation = function () {
        $scope.showPasswordConfirmation = !$scope.showPasswordConfirmation;
        if ($scope.inputTypeConfirmation == 'password')
            $scope.inputTypeConfirmation = 'text';
        else
            $scope.inputTypeConfirmation = 'password';
    }

    $scope.checkPassword = function () {
        if ($scope.ConfirmPassword != $scope.user.Password) {
            $scope.formRegister.txtConfirmPassword.$invalid = true;
            $scope.infolengthpass = false;
        }
    };


    var allPromise = $q.all([
        appFactory.getData(`/service/client.svc/GetCountryPhone`).then(function (data) {

            if (data.status == 200)
                $scope.ListCountryPhone = data.data.d;
        }),
        appFactory.getData(`/service/client.svc/GetCIFSales`).then(function (data) {

            if (data.status == 200)
                $scope.ListSales = data.data.d;
        }),
         appFactory.getData(`/service/client.svc/GetCIFBank`).then(function (data) {

             if (data.status == 200)
                 $scope.ListBank = data.data.d;
         }),
    ]);

    allPromise.then(function () {

    });

    // when sales is selected
    $scope.selectSales = function (item, model, label, event) {

        if (item.SalesPersonNID) {
            $scope.user.Sales = item.SalesPersonNID;
            $scope.SalesSelected = item;
        }
    };

    // check bank number duplication
    $scope.checkBankNumber = function () {
        if ($scope.user.BankNumber) {

            appFactory.getData(`/service/client.svc/checkBankNumber?BK=${$scope.user.BankNumber}`).then(function (data) {

                if (data.status == 200) {

                    if (data.data.d != null) {
                        var obj = data.data.d;
                        if (obj.key && obj.key == 1) {
                            $scope.user.BankNumber = '';
                            Swal.fire('Failed', obj.value, "error");
                        }
                    }
                }
            });
        }
    }

    // jika url ke: register/{id sales} maka sales selected auto
    //if ($routeParams.id) {

    //    appFactory.getData(`/service/client.svc/GetAliasSales?alias=${$routeParams.id}`).then(function (data) {

    //        if (data.status == 200) {
    //            // jika id sales di temukan maka:
    //            if (data.data.d.SalesPersonNID > 0) {

    //                $scope.user.Sales = data.data.d.SalesPersonNID;
    //                $scope.SalesSelected = data.data.d;
    //                $scope.disablesales = true;
    //            }
    //        }
    //    });
    //}

    if ($routeParams.id == "BACA") {

        $scope.user.QuestionRDN = 26;
        $scope.disableBCA = true;
    }

    if ($routeParams.id == "BCA") {

        $scope.user.QuestionRDN = 1;
        $scope.disableBACA = true;
    }

    // variables before submit post
    $scope.prepareData = function () {
      
        if ($scope.user.Sales == "")
            $scope.user.Sales = 133;

        $scope.user.BankName = $scope.bankpribadi;
    }

    $scope.submit = function () {

        var challenge = grecaptcha.getResponse();
        if (!challenge) {
            alert("Mohon ulangi centang captcha");
            return false;
        }
        else {
            $scope.user.challenge = challenge;
        }

        $scope.prepareData();
        
        // dynamic sweet alert post to app.js
        // 1: set the url of post or get request
        // 2: set the sweet alert translation, refers to apps.js $scope.SWALtranslate() :preconfirm = confirmation dialog before post or get request
        // 3: set the postdata to $http request = GET : {} / POST { yourdata : data }
        // 4: set the method to $http request = "GET" / "POST"
        // 5: set the sweet alert translation, refers to apps.js $scope.SWALtranslate() :preconfirm = confirmation dialog before post or get request
        // 6: if success or no error returns then...
        var urlsvc = '/service/client.svc/RegistrasiUser'; // 1
        var preconfirmtranslate = "submitregistrationconf"; // 2
        var postData = { User: $scope.user } // 3
        var method = "POST" // 4
        $scope.PostGetSwal(preconfirmtranslate, urlsvc, postData, method, function (issuccess) {

            if (issuccess) // 6
                $window.location.href = "#/login";
        });
    }

    $scope.validationinput = function () {

        if ($scope.user.FirstName != null                     
            && $scope.user.Email != null
            && $scope.user.Handphone != null
            && $scope.user.BankOwner != null
            && $scope.user.BankNumber != null
            && $scope.user.Password != null
            && $scope.ConfirmPassword != null
            && $scope.disclaimerRek != null
           ) {
            console.log('validation success');
        }
        else {
            var SWALtranslate = $scope.SWALtranslate('validationinput');

            Swal.fire({
                title: SWALtranslate.title,
                text: SWALtranslate.message,
                imageUrl: 'img/collection/wrong.png',
                imageAlt: 'Preparation',
                imageHeight: 250,
                animation: false
            });
        }
    }
}]);
